<template>
  <keep-alive :include="['AdminPublications', 'AdminOrders', 'AdminPublications', 'AdminSignatures', 'AdminUsers', 'AdminExpeditions']">
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'App'
}
</script>